/**
 * @file       Zip code input directive for 12345 or 12345-6789 format
 * @version    1.0.0
 * @author     Boris Veits
 * @copyright  Copyright (c) 2018, MindShare HDV LLC.  All rights reserved.
 *             Property of MindShare HDV LLC.  This file cannot be used or 
 *             altered in anyway without expressed written permission from 
 *             MindShare HDV LLC.
 */
import { Directive, ElementRef, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive
({
    selector: '[appZipCodeInput]',
    standalone: false
})

/**
 * @desc   - directive for allowing only numbers in zip code format
 */
class ZipCodeInputDirective 
{
    private updating: boolean;

    /**
     * @desc   - directive constructor
     * @access - public
     * @param  - el : ElementRef
     * @param  - ngControl : NgControl (optional)
     * @return - 
     */
    constructor
    (
        private el: ElementRef,
        @Optional() private ngControl: NgControl
    ) 
    {
        this.updating = false;
    }

    //__________________ P R I V A T E  M E T H O D S __________________________

    /**
     * @desc - format the zip code digits
     * @access - private
     * @param  - digits : string - the digits to format
     * @returns - string
     */
    private formatZipCodeDigits
    (
        digits: string
    ) : string
    {
        let result: string;

        digits = digits.replace(/\D/g, '');

        if (digits.length <= 5)
        {
            result = digits;
        }
        else if (digits.length <= 9)
        {
            result = digits.substring(0, 5) + '-' + digits.substring(5);
        }
        else
        {
            result = digits.substring(0, 5) + '-' + digits.substring(5, 9);
        }

        return result;
    }

    //___________________ P U B L I C  M E T H O D S ___________________________

    /**
     * @desc  - handle the user typing in the field and format as zip code
     * @access - public
     * @param  - event: InputEvent - the input event from the field
     * @return - 
     */
    @HostListener('input', ['$event'])
    onInput
    (
        event: InputEvent
    ) 
    {
        let input;
        let inputValue;
        let formattedValue;

        if (!this.updating)
        {
            input = event.target as HTMLInputElement;
            inputValue = input.value;

            formattedValue = this.formatZipCodeDigits(inputValue);

            input.value = formattedValue;

            if (this.ngControl?.control) 
            {
                this.updating = true;
                this.ngControl.control.setValue(formattedValue);
                this.updating = false;
            }
        }
    }
}

export { ZipCodeInputDirective };
